// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
import DefaultFields from "../../components/DefaultFields/DefaultFields";

// HELPERS
import {createClassName} from "@helpers/utils";
import * as CobHelpers from "../../Cob.helpers";
import fulfillmentCheck from "./Fullmaktstagare.fulfillment";
import EditableField from "../../components/EditableField/EditableField";
import FieldsCollection from "../../../../components/FieldsCollection/FieldsCollection";
import Validator from "../../../../classes/Validator";


export default class Fullmaktstagare extends React.PureComponent
{
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	static companyExclusive = false;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState)
	{
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields)
		{
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render()
	{
		const {props, state} = this;
		const {title, partner} = props;
		const appConfig = partner.appSpecificConfiguration;

		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		const showAddressFields = appConfig.showAddressFields && appConfig.showAddressFields === true;

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<FieldsCollection
						fieldsPerRow={2}
						fields={[
							{
								render: (
									<EditableField
										name="proxy_holder_name"
										label={"Namn / Firma"}
										value={state.fields.proxy_holder_name}
										valid={state.fields.proxy_holder_name ? state.fields.proxy_holder_name.length > 0 : null}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
									/>
								),
							},
							{
								render: (
									<EditableField
										name="proxy_holder_identity"
										label={"Person- / Organisationsnummer"}
										placeholder={"XXXXXXXX-YYYY"}
										value={state.fields.proxy_holder_identity}
										valid={state.fields.proxy_holder_identity ?
											(
												Validator.validateOrgNum(state.fields.proxy_holder_identity, true) ||
												Validator.validateSsn(state.fields.proxy_holder_identity, false)
											)
											: null}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
									/>
								)
							}
						]}
					/>

					{showAddressFields && (
						<FieldsCollection
							fieldsPerRow={3}
							fields={[
								{
									render: (
										<EditableField
											name="proxy_holder_street"
											label="Utdelningsadress"
											value={state.fields.proxy_holder_street}
											valid={state.fields.proxy_holder_street ? state.fields.proxy_holder_street.length > 0 : null}
											onChange={this._onFieldChange}
											onBlur={this._onFieldBlur}
											required
										/>
									),
								},
								{
									render: (
										<EditableField
											name="proxy_holder_zip"
											label="Postnummer"
											value={state.fields.proxy_holder_zip}
											valid={state.fields.proxy_holder_zip ? state.fields.proxy_holder_zip.length > 0 : null}
											onChange={this._onFieldChange}
											onBlur={this._onFieldBlur}
											required
										/>
									),
								},
								{
									render: (
										<EditableField
											name="proxy_holder_city"
											label="Postort"
											value={state.fields.proxy_holder_city}
											valid={state.fields.proxy_holder_city ? state.fields.proxy_holder_city.length > 0 : null}
											onChange={this._onFieldChange}
											onBlur={this._onFieldBlur}
											required
										/>
									),
								}
							]}
						/>
					)}

					<FieldsCollection
						fieldsPerRow={2}
						fields={[
							{
								render: (
									<EditableField
										type="tel"
										name="proxy_holder_phone"
										label="Telefon"
										value={state.fields.proxy_holder_phone}
										valid={null}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
									/>
								),
							},
							{
								render: (
									<EditableField
										type="email"
										name="proxy_holder_email"
										label="E-postadress"
										value={state.fields.proxy_holder_email}
										valid={state.fields.proxy_holder_email ? Validator.validateEmail(state.fields.proxy_holder_email) : null}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
									/>
								)
							}
						]}
					/>
				</div>
			</div>
		);
	}

	// Internal methods
	_fieldValidator = (name, value) => {
		if (name === "proxy_holder_identity")
		{
			return Validator.validateOrgNum(value, true) || Validator.validateSsn(value, false);
		}
		else
		{
			return value.length > 0;
		}
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};
}


// PRIVATE FUNCTIONS
function _getFields()
{
	return [
		"proxy_holder_name",
		"proxy_holder_identity",
		"proxy_holder_street",
		"proxy_holder_zip",
		"proxy_holder_city",
		"proxy_holder_phone",
		"proxy_holder_email",
	];
}

function _getInitialState()
{
	if (this.props.prevState)
	{
		return {...this.props.prevState};
	}

	const {partner} = this.props;
	const appConfig = partner.appSpecificConfiguration;

	return {
		validFields: {},
		fields: {
			"requireAddress": (appConfig.showAddressFields && appConfig.showAddressFields === true),
			"proxy_holder_name": "",
			"proxy_holder_identity": "",
			"proxy_holder_street": "",
			"proxy_holder_zip": "",
			"proxy_holder_city": "",
			"proxy_holder_phone": "",
			"proxy_holder_email": "",
		},
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fullmakt/Fullmaktstagare.js